import styled, { css } from 'styled-components'
import { tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section(
    ({ theme }) => css`
        padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
        display: flex;
        flex-direction: column;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.spacing.xLarge} ${theme.spacing.large} ${theme.spacing.medium};
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: ${theme.spacing.xLarge} 4rem ${theme.spacing.medium};
        }
    `,
)

export const TitleContainer = styled.div(
    ({ theme }) => css`
        padding: ${theme.spacing.small} 0 ${theme.spacing.xxSmall};
        margin-bottom: ${theme.spacing.medium};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-bottom: ${theme.spacing.large};
        }
    `,
)

export const Title = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.large};
        font-weight: ${theme.typography.font.weight.bold};
        line-height: 1.75rem;
        color: ${theme.colors.tfwBlack87};
        margin: 0;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.xLarge};
            line-height: 1.875rem;
        }
    `,
)

export const TableWrapper = styled.div(
    ({ theme }) => css`
        background: ${theme.colors.white};
        border-radius: ${theme.spacing.xSmall};
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    `,
)

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`

export const TableRow = styled.tr(
    ({ theme }) => css`
        border-bottom: 1px solid ${theme.colors.tfwBlack12};

        &:last-child {
            border-bottom: none;
        }
    `,
)

export const TableHeaderCell = styled.th(
    ({ theme }) => css`
        text-align: ${theme.style.textAlign.left};
        padding: ${theme.spacing.medium} ${theme.spacing.large};
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        font-weight: ${theme.typography.font.weight.bold};
        color: ${theme.colors.tfwBlack87};
        background-color: ${theme.colors.tfwBlack3};
        border-bottom: 2px solid ${theme.colors.tfwBlack12};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.typography.font.size.large} ${theme.spacing.large};
            font-size: ${theme.typography.font.size.medium};
        }
    `,
)

export const TableCell = styled.td(
    ({ theme }) => css`
        padding: ${theme.spacing.small} ${theme.spacing.small};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.large};
        font-family: ${theme.typography.font.family.lato};
        color: ${theme.colors.tfwBlack87};
        vertical-align: top;
        word-break: break-word;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: ${theme.typography.font.size.large} ${theme.spacing.large};
            font-size: ${theme.typography.font.size.medium};
        }

        &:first-child {
            color: ${theme.colors.tfwBlack45};
        }

        &:last-child {
            color: ${theme.colors.tfwBlack87};
        }
    `,
)
